const SPORTS = {
  SPORTS_FETCH_START: 'SPORTS_FETCH_START',
  SPORTS_FETCH_SUCCESS: 'SPORTS_FETCH_SUCCESS',
  SPORTS_FETCH_ERROR: 'SPORTS_FETCH_ERROR'
}

export default SPORTS
